import BlockUi from '../blockUi/BlockUi';
import { useLoadScript } from '@react-google-maps/api';

const MAP_LIBRARIES = ['places', 'drawing', 'geometry', 'marker'];
export default function withMap(WrappedComponent) {
    const ComponentWrapper = (props) => {
        const { isLoaded } = useLoadScript({
            googleMapsApiKey: window.ENV.GOOGLE_MAPS_API_KEY,
            libraries: MAP_LIBRARIES,
            version: '3.64',
            channel: 'au_rppcrux_test',
        });
        return (
            <BlockUi
                renderChildren={false}
                blocking={!isLoaded}
                containerProps={{
                    className: 'with-map-block-ui',
                    position: 'relative',
                    containerCss: { minHeight: '50vh' }
                }}
                backdropProps={{ style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.3);',
                    }}}
            >
                <WrappedComponent {...props} />
            </BlockUi>
        );
    };

    return ComponentWrapper;
}
